import { createFileRoute } from "@tanstack/react-router";
import {
  CommercialHubPage,
  COMMERCIAL_HUB_FAQS,
} from "@/components/commercial/commercial-hub-page";
import { withServiceLcpPreload } from "@/lib/service-lcp-preload";
import { pageSeo, serviceJsonLdScript } from "@/lib/seo";
import { SITE } from "@/lib/site";

const PATH = "/commercial";
const TITLE = "Commercial Retrofit & Public Sector | CRS Energy";
const DESCRIPTION =
  "Framework-ready commercial and public-sector delivery for retrofit, heating, renewables and remedial works, with documented quality and reporting.";

export const Route = createFileRoute("/commercial")({
  head: () =>
    withServiceLcpPreload(PATH, {
    ...pageSeo({
      path: PATH,
      title: TITLE,
      description: DESCRIPTION,
      ogType: "article",
    }),
    scripts: [
      serviceJsonLdScript({
        name: "Commercial & Public Sector",
        description: DESCRIPTION,
        serviceType: "Commercial Retrofit & Remedial Services",
        url: `${SITE.url}${PATH}`,
      }),
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: COMMERCIAL_HUB_FAQS.map((f) => ({
            "@type": "Question",
            name: f.question,
            acceptedAnswer: { "@type": "Answer", text: f.answer },
          })),
        }),
      },
    ],
  }),
  component: () => <CommercialHubPage />,
});
